module.exports = __webpack_public_path__ + "static/media/benefits1.ce7ac9ce.png";